let e = [], o = null, c = !1, h = null;
function k(n, t, f, i) {
  const { isRefreshToken: u = !1, refreshFun: a, refreshCb: l } = f || {};
  if (!u || n.code != 401) return n;
  if (l) return void l();
  const r = new Promise((s, g) => {
    e.push({ config: t.config, resolve: s, reject: g });
  });
  return o || (o = c ? Promise.resolve() : a().then(() => {
    c = !0, o = null, d(i);
  }).catch((s) => {
    console.error("[checkLoginExpired] Token refresh failed:", JSON.stringify(s)), e.forEach(({ reject: g }) => g(s)), e = [], o = null;
  })), o.then(() => (c && e.length ? d(i, () => {
    c = !1;
  }) : h || (h = setTimeout(() => {
    c = !1, clearTimeout(h), h = null;
  }, 6e4)), r));
}
function d(n, t) {
  const f = e.length;
  e.forEach(({ config: i, resolve: u, reject: a }, l) => {
    n(i).then((r) => {
      u(r);
    }).catch((r) => {
      a(r);
    }).finally(() => {
      l == f - 1 && t && t();
    });
  }), e = [];
}
export {
  k as checkLoginExpired
};
